export default "__VITE_ASSET__DE8MdhGw__"